import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/notify/style";
import _Notify from "vant/es/notify";
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import "core-js/modules/es.array.push.js";
import { getToken } from '@/utils/auth';
import Bus from '@/utils/bus.js';
import { submitcar, getPayConfigOther } from '@/api/user';
import { getPayConfig } from '@/api/order';
export default {
  data() {
    return {
      columns: ['10万', '20万', '50万', '100万', '200万', '300万'],
      isAlert: false,
      show: false,
      checked: false,
      actionSheetShow: false,
      paywayShow: false,
      phone: '',
      payways: ['微信支付', '余额支付'],
      vShowMoney: '980元',
      payindex: 0,
      values: {},
      uInfo: {},
      sn: '',
      list: {
        name: '',
        idCard: '',
        phone: '',
        brand: '',
        generatorNumber: '',
        frameNumber: '',
        desc: '',
        price: '',
        type: 11,
        isbuyer: 1,
        earnestMoney: '',
        mileage: '',
        color: '',
        basePlate: '',
        carType: '',
        yearMoney: '',
        initiateTime: '',
        stages: '',
        amount: '',
        occupy: '',
        downPayment: '',
        payMonthly: ''
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    console.log(to);
    //to是当前页面,from是从哪里来,next是放行
    if (to.query.type) {
      if (to.query.type == 11) {
        document.title = '二手车买卖合同(简易版)'; //获取从上个页面传过来的name再进行修改
      } else if (to.query.type == 12) {
        document.title = '二手车买卖合同（通用版)';
      } else if (to.query.type == 13) {
        document.title = '二手车买卖合同(质保版)';
      } else if (to.query.type == 14) {
        document.title = '汽车分期买卖合同(分期付款)';
      }
    }
    next(); //切记操作完一定要记得放行,否则无法正常跳转页面
  },

  created(e) {
    this.list.isbuyer = this.$route.query.isbuyer;
    this.list.type = this.$route.query.type;
    if (!getToken()) {
      console.log('no token');
      this.$router.push('/login');
      return;
    }
    let that = this;
    let uInfo = JSON.parse(localStorage.getItem('xinguserInfo'));
    console.log(uInfo.isMing);
    if (uInfo.isMing != 1) {
      console.log('show diglog');
      _Dialog.confirm({
        title: '提示',
        message: '未完成实名认证，请先认证'
      }).then(() => {
        // on confirm
        that.$router.push('/shiming');
      }).catch(() => {
        that.$router.go(-1);
      });
      return;
    }
    this.uInfo = uInfo;
    this.$wx.ready(function () {
      console.log('wx read');
      that.wxReady = true;
    });
  },
  mounted() {
    this.activated();
  },
  beforeDestroy() {
    // Bus.$off("Data",this.activated());
  },
  methods: {
    onAmount(value, index) {
      this.list.amount = value;
      this.isAlert = false;
    },
    onCancel() {
      this.isAlert = false;
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      this.show = false;
      this.list.initiateTime = this.formatDate(date);
    },
    activated() {
      Bus.$on('Data', data => {
        //赋值给当前页面的值
        console.log(data, '222');
        this.list.name = data.name;
        this.list.phone = data.phone;
        this.list.idCard = data.idCard;
        console.log(this.list);
      });
      console.log(this.list);
    },
    up() {
      if (!this.list.name) {
        _Notify({
          type: 'danger',
          message: '请填写对方姓名'
        });
        return;
      }
      if (this.list.type == 12 || this.list.type == 13) {
        if (!this.list.earnestMoney) {
          _Notify({
            type: 'danger',
            message: '请填写定金'
          });
          return;
        }
        if (!this.list.mileage) {
          _Notify({
            type: 'danger',
            message: '请填写行驶里程'
          });
          return;
        }
      }
      if (!this.list.price) {
        _Notify({
          type: 'danger',
          message: '请填写总价格'
        });
        return;
      }
      if (this.list.type == 11) {
        if (!this.list.desc) {
          _Notify({
            type: 'danger',
            message: '请填写车辆概况'
          });
          return;
        }
      }
      if (!this.list.frameNumber) {
        _Notify({
          type: 'danger',
          message: '请填写车架号'
        });
        return;
      }
      if (!this.list.generatorNumber) {
        _Notify({
          type: 'danger',
          message: '请填写发动机号'
        });
        return;
      }
      if (!this.list.brand) {
        _Notify({
          type: 'danger',
          message: '请填写车辆品牌'
        });
        return;
      }
      if (this.list.type == 14) {
        if (!this.list.color) {
          _Notify({
            type: 'danger',
            message: '请填写外观颜色'
          });
          return;
        }
        if (!this.list.basePlate) {
          _Notify({
            type: 'danger',
            message: '请填写底盘号'
          });
          return;
        }
        if (!this.list.carType) {
          _Notify({
            type: 'danger',
            message: '请填写车型'
          });
          return;
        }
        if (!this.list.yearMoney) {
          _Notify({
            type: 'danger',
            message: '请填写每月付款日'
          });
          return;
        }
        if (!this.list.initiateTime) {
          _Notify({
            type: 'danger',
            message: '请选择分期起始日'
          });
          return;
        }
        if (!this.list.stages) {
          _Notify({
            type: 'danger',
            message: '请填写分期期数'
          });
          return;
        }
        if (!this.list.amount) {
          _Notify({
            type: 'danger',
            message: '请填写第三者商业险金额'
          });
          return;
        }
        if (!this.list.occupy) {
          _Notify({
            type: 'danger',
            message: '请填写每月月资金占用费'
          });
          return;
        }
        if (!this.list.downPayment) {
          _Notify({
            type: 'danger',
            message: '请填写首付金额'
          });
          return;
        }
        if (!this.list.payMonthly) {
          _Notify({
            type: 'danger',
            message: '请填写分期月付金额'
          });
          return;
        }
      }
      submitcar(this.list).then(res => {
        console.log(res);
        if (res.code == 200) {
          _Notify({
            type: 'success',
            message: '提交成功'
          });
          this.paywayShow = false;
          this.actionSheetShow = true;
          this.sn = res.data.sn;
        } else {
          _Notify({
            type: 'danger',
            message: '提交失败'
          });
        }
      });
    },
    changePayWays(index) {
      if (index == 1) {
        _Toast('余额不足，请重新选择');
        return;
      }
      this.paywayShow = false;
    },
    toPay() {
      if (!this.wxReady) {
        _Toast('微信登录中，请稍候，或者刷新重试');
        return;
      }
      let that = this;
      this.actionSheetShow = false;
      // this.values.status = -1
      let param = {
        'sn': that.sn,
        'openid': that.uInfo.openid,
        'type': 1
      };
      getPayConfigOther(param).then(resp => {
        if (resp.code == 200) {
          let data = resp.data;
          that.$wx.chooseWXPay({
            timestamp: data.timeStamp,
            // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
            nonceStr: data.nonceStr,
            // 支付签名随机串，不长于 32 位
            package: data.package,
            // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: data.signType,
            // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
            paySign: data.paySign,
            // 支付签名
            success: function (res) {
              // 支付成功后的回调函数
              console.log('pay success');
              console.log(res);
              // let upparam = {
              // 	sn: that.sn,
              // 	avatar: that.uInfo.headimgurl
              // }
              // uploadAvatar(upparam);

              // that.status = 1;
              // that.pay_time = 1;
              that.$router.push('orderinfo?isShare=0&sn=' + that.sn);
            }
          });
        }
      });
    },
    changes() {
      this.checked = !this.checked;
    },
    toPdf() {
      this.$router.push('/look');
    },
    toBuy() {
      this.$router.push('/erji/car/car/changeBuy');
    }
  }
};